import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ClaimComplete() {
  const navigate = useNavigate();
  const [giftInfo, setGiftInfo] = useState(null);

  useEffect(() => {
    // Retrieve gift info from localStorage
    const stored = localStorage.getItem('claiming_gift');
    if (stored) {
      setGiftInfo(JSON.parse(stored));
      localStorage.removeItem('claiming_gift');
    }
  }, []);

  return (
    <div className="max-w-md mx-auto mt-10">
      <div className="bg-green-100 border border-green-400 text-green-700 p-6 rounded-lg">
        <h1 className="text-2xl font-bold mb-4">🎉 Account Setup Complete!</h1>

        {giftInfo && (
          <div className="bg-white p-4 rounded border border-green-300 mb-4">
            <p className="text-lg font-semibold text-gray-800 mb-2">
              ${giftInfo.amount} from {giftInfo.giver_name}
            </p>
            <p className="text-sm text-gray-600">
              Your gift will be transferred automatically to your bank account.
            </p>
          </div>
        )}

        {!giftInfo && (
          <div className="bg-white p-4 rounded border border-green-300 mb-4">
            <p className="text-sm text-gray-600">
              Your account setup is complete! Funds will be transferred automatically.
            </p>
          </div>
        )}

        <div className="space-y-2 text-sm">
          <p>
            <strong>What happens next:</strong>
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Funds will be transferred automatically within minutes</li>
            <li>Money arrives in your bank in 1-2 business days</li>
            <li>You'll receive a confirmation email</li>
          </ul>
        </div>

        <div className="mt-6 pt-4 border-t border-green-300">
          <p className="text-xs text-gray-600 mb-3">
            Powered by Stripe Connect - Secure, compliant money transfers
          </p>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700 transition-colors"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClaimComplete;
